module.exports = __webpack_public_path__ + "static/media/emanuelRuiz.54733659.jpg";